import { Component, EventEmitter, Input, Output } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { EJobType } from '../job-type.enum';
import { IJob } from '../IJob';

@Component({
  selector: 'job-steps-readonly',
  templateUrl: 'jobs-steps-readonly.component.html',
  styleUrls: ['jobs-steps-readonly.component.scss']
})
export class JobsStepsReadOnlyComponent {
  @Input() applyDisabled = false;
  @Input() currentJob;
  @Input() jobType: EJobType;
  @Input() areOtherTabsValid: boolean = false;
  @Input() jobStates: { [key: string]: { rescheduleJob: boolean, switchActivated: boolean, originalNextRuntimeDate: Date, nextRuntimeDate: Date } } = {};  
  
  public jobTypes = EJobType;  

}
